import { Component, signal, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { StatisticData } from '../../models/statistic';

@Component({
    standalone: true,
    selector: 'app-stats-widget',
    imports: [CommonModule],
    template: `
        <div class="grid grid-cols-12 gap-6">
        @for (stat of statsList(); track stat.label) {
            <div class="col-span-12 md:col-span-6 xl:col-span-3">
                <div class="card min-h-[150px] flex flex-col justify-between">
                    <div>
                        <span class="block text-muted font-medium mb-2">{{ stat.label }}</span>
                        <div class="text-surface-900 dark:text-surface-0 font-bold text-xl">
                            {{ stat.value }}
                        </div>
                    </div>
                    <div class="flex items-center justify-center" [ngClass]="stat.bgColor" style="border-radius: 50%; width: 2.5rem; height: 2.5rem;">
                        <i [class]="stat.icon + ' ' + stat.iconColor + ' text-2xl'"></i>
                    </div>
                </div>
            </div>
        }
    `
})
export class StatsWidget implements OnInit {
    private http = inject(HttpClient);
    stats = signal<StatisticData | null>(null);
    statsList = signal<{ label: string; value: string | number; icon: string; iconColor: string; bgColor: string }[]>([]);


    ngOnInit() {
        this.http.get<StatisticData>(`${environment.apiConfig.baseUrl}/v1/statisticdata`).subscribe({
            next: (data) => {
                this.stats.set(data);
                this.statsList.set([
                    { label: "Totale acqua bevuta", value: `${data.numberTotalLiter} litri`, icon: "pi pi-water", iconColor: "text-blue-500", bgColor: "bg-blue-100" },
                    { label: "Bottiglie risparmiate", value: `${data.totalBottles} bottiglie`, icon: "pi pi-recycle", iconColor: "text-green-500", bgColor: "bg-green-100" },
                    { label: "CO2 risparmiata", value: `${data.co2Saved.toFixed(0)} kg`, icon: "pi pi-cloud", iconColor: "text-cyan-500", bgColor: "bg-cyan-100" },
                    { label: "CO2 potenzialmente risparmiata", value: `${data.co2PotentialSaved.toFixed(0)} kg`, icon: "pi pi-chart-line", iconColor: "text-cyan-700", bgColor: "bg-cyan-200" },
                    { label: "Check-in effettuati", value: data.numberCheckin, icon: "pi pi-map-marker", iconColor: "text-orange-500", bgColor: "bg-orange-100" },
                    { label: "Check-in Fontanelle a Muro", value: data.numberCheckinsMuro, icon: "pi pi-home", iconColor: "text-teal-500", bgColor: "bg-teal-100" },
                    { label: "Check-in Colonna", value: data.numberCheckinColonna, icon: "pi pi-building", iconColor: "text-gray-500", bgColor: "bg-gray-100" },
                    { label: "Check-in Monumentale", value: data.numberCheckinMonumentale, icon: "pi pi-map", iconColor: "text-yellow-500", bgColor: "bg-yellow-100" },
                    { label: "Check-in Casetta", value: data.numberCheckinCasetta, icon: "pi pi-map-marker", iconColor: "text-purple-500", bgColor: "bg-purple-100" },
                    { label: "Numero di recensioni", value: data.numberReview, icon: "pi pi-star", iconColor: "text-purple-500", bgColor: "bg-purple-100" },
                    { label: "Recensioni con foto", value: data.numberReviewWithPhoto, icon: "pi pi-camera", iconColor: "text-pink-500", bgColor: "bg-pink-100" },
                    { label: "Litri da fontane", value: `${data.numberTotalLiterFountain} litri`, icon: "pi pi-filter", iconColor: "text-blue-700", bgColor: "bg-blue-200" },
                    { label: "Litri da casa", value: `${data.numberTotalLiterHome} litri`, icon: "pi pi-home", iconColor: "text-green-700", bgColor: "bg-green-200" },
                    { label: "Plastica risparmiata", value: `${data.totalAmountPlastic.toLocaleString()} g`, icon: "pi pi-trash", iconColor: "text-red-500", bgColor: "bg-red-100" },
                    { label: "Numero totale plastica", value: data.totalNumberPlastic, icon: "pi pi-shopping-cart", iconColor: "text-gray-700", bgColor: "bg-gray-200" },
                    { label: "Bottiglie potenzialmente risparmiate", value: data.totalBottlesPotential, icon: "pi pi-globe", iconColor: "text-green-700", bgColor: "bg-green-200" }
                ]);
            },
            error: (error) => console.error("Errore nel caricamento delle statistiche", error)
        });
    }
}
